// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimReimbursementDetails = t.struct({
    recoverPercentage: t.Number,
    totalApproved: t.maybe(t.Number)
}, {
    name: 'ClaimReimbursementDetails',
    strict: true
});

export const getDefaultState = () => new ClaimReimbursementDetails({
    recoverPercentage: 0,
    totalApproved: null
});

export default ClaimReimbursementDetails;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-reimbursement-details.js